import { apiService } from './api';

export interface GroupMembershipResponse {
  groupId: string;
  isMember: boolean;
}

const basePath = '/api/permissions/groups';

export const groupManagementService = {
  async addCurrentUserToGroup(groupId: string): Promise<GroupMembershipResponse> {
    const response = await apiService.post<GroupMembershipResponse>(`${basePath}/${groupId}/members`, {
      action: 'add'
    });
    return response;
  },

  async removeCurrentUserFromGroup(groupId: string): Promise<GroupMembershipResponse> {
    const response = await apiService.post<GroupMembershipResponse>(`${basePath}/${groupId}/members`, {
      action: 'remove'
    });
    return response;
  }
};
